import type { ChildrenProps } from '@/types/common.types';

import styles from '@/components/MoviesTopPanel/MoviesTopPanel.module.scss';

export const MoviesTopPanel = (props: ChildrenProps) => {
  const { children } = props;

  return <div className={styles.moviesTopPanel}>{children}</div>;
};
